import { decode, formatPrice } from 'utils/general';
import { cleanseProductJson } from '../../assets/js/utils/general';

export default {
  components: {
    'vue-image': () => import('../vue-image/vue-image.vue'),
    'vue-image-v2': () => import('../vue-image-v2/vue-image-v2.vue'),
    'product-selector': () =>
      import('../product-selector/product-selector.vue'),
  },
  props: ['variants', 'line-key', 'quantity'],
  data() {
    return {
      currentVariant: null,
    };
  },
  computed: {
    variantsParsed() {
      return JSON.parse(decode(this.variants));
    },
    variant() {
      if (this.currentVariant) return this.currentVariant;
      const cleansedVariant = cleanseProductJson(this.variantsParsed[0]);
      const bundleVariant = cleansedVariant.variants.find(
        (variant) => variant.isBundleVariant === 'true',
      );
      if (bundleVariant) {
        return {
          ...cleansedVariant,
          variants: bundleVariant,
          price: bundleVariant.price,
          featuredImage: bundleVariant.image.src
        };
      }
      return cleansedVariant;
    },
    price() {
      return this.variant.price ? formatPrice(this.variant.price, true) : '';
    },
    compareAtPrice() {
      return this.variant.compareAtPrice
        ? formatPrice(this.variant.compareAtPrice, true)
        : '';
    },
  },
  methods: {
    onChangeProduct(variant) {
      this.currentVariant = variant;
      this.emitProductChange();
    },
    emitProductChange() {
      this.$emit('product-change', {
        product: this.variant,
        key: this.lineKey,
      });
    },
  },
  mounted() {
    this.emitProductChange();
  },
};
